(() => {
	const tags = document.querySelectorAll("[js-hb-inspiration-tag-item]");

	tags.forEach((tagBtn) => {
		tagBtn.addEventListener("click", () => {
			const parent = tagBtn.closest(".tabcontent");
			const index = parent.getAttribute("data-index");
			const category = document.getElementById(`inspiration-category-${index}`);
			const items = category.querySelectorAll("[js-hb-item]");

			tags.forEach((tagBtn) => {
				tagBtn.classList.remove("Active");
			});
			tagBtn.classList.add("Active");

			const tagValue = tagBtn.getAttribute("data-value");

			items.forEach((item) => {
				item.classList.add("hidden");
			});

			const selectedItemsBaseOnTag = category.querySelectorAll(
				`[js-hb-item].hb-${tagValue}`
			);

			selectedItemsBaseOnTag.forEach((item) => {
				item.classList.remove("hidden");
			});
		});
	});
})();
